import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
  Label,
  CardFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// Actions
import { ticketList, ticketFilter } from "store/billing/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Pagination from "components/Common/Pagination";
import Loader from "components/Common/Loader";
import Pagination2 from "components/Common/Pagination2";
import TicketDelete from "pages/Dashboard/Tickets/Delete";

const TicketList = (props) => {
  const dispatch = useDispatch();
  const fechaActual = new Date();
  const dia = fechaActual.getDate();
  const mes = fechaActual.getMonth() + 1;
  const anio = fechaActual.getFullYear();

  const fechaString = `${anio}-${mes < 10 ? "0" + mes : mes}-${
    dia < 10 ? "0" + dia : dia
  }`;

  useEffect(() => {
    dispatch(
      ticketFilter(
        `?search=&state=&created_date_after=${fechaString}&created_date_before=${fechaString}`
      )
    );
  }, []);

  const [search, setSearch] = useState("");
  const [createdDateRange, setCreatedDateRange] = useState([
    fechaActual,
    fechaActual,
  ]);
  const [state, setState] = useState("");

  const [modal, setModal] = useState(false);
  const [ticket, setTicket] = useState({
    code: "",
    consecutive: "",
  });
  const toggle = () => setModal(!modal);

  const onChange1 = (e) => {
    setSearch(e.target.value);
  };

  const onChange2 = (createdDateRange) => {
    setCreatedDateRange(createdDateRange);
  };

  const onChange3 = (e) => {
    setState(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    dispatch(
      ticketFilter(
        `?search=${search}&state=${state}&created_date_after=${date_1}&created_date_before=${date_2}`
      )
    );
  };

  const resetFilter = () => {
    setSearch("");
    setCreatedDateRange([fechaActual, fechaActual]);
    setState("");
    dispatch(
      ticketFilter(
        `?search=&state=&created_date_after=${fechaString}&created_date_before=${fechaString}`
      )
    );
  };

  const params = {
    count: props.tickets.count,
    next: props.tickets.next,
    previous: props.tickets.previous,
    results: props.tickets.results,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Tickets </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Tickets"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-start">
                      <Col lg={2}>
                        <Link
                          className="btn btn-success waves-effect waves-light"
                          to="/tickets/create"
                        >
                          Registrar entrada
                        </Link>
                      </Col>
                      <Col lg={2}>
                        <InputGroup>
                          <Flatpickr
                            className="form-control"
                            placeholder="dd/mm/aaaa"
                            value={createdDateRange}
                            onChange={onChange2}
                            options={{
                              mode: "range",
                              dateFormat: "d/m/Y",
                              locale: Spanish,
                            }}
                          />
                        </InputGroup>
                      </Col>
                      <Col lg={2}>
                        <Input
                          type="select"
                          className="form-select"
                          name="state"
                          id="state"
                          value={state}
                          onChange={onChange3}
                        >
                          <option value="" defaultValue>
                            Todos
                          </option>
                          <option value="recibido">Recibido</option>
                          <option value="entregado">Entregado</option>
                        </Input>
                      </Col>
                      <Col lg={3} className="search-box">
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            id="search"
                            value={search}
                            onChange={onChange1}
                            placeholder="Ticket, cliente..."
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </InputGroup>
                      </Col>
                      <Col lg={2}>
                        <Button color="light" type="submit">
                          Filtrar
                        </Button>
                        <Button
                          className="ms-2"
                          color="secondary"
                          onClick={resetFilter}
                        >
                          Borrar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              <Card>
                {params.count > 0 ? (
                  <CardBody className="ps-5 pe-5">
                    <div className="table-responsive">
                      <Table
                        className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Código cliente</th>
                            <th>Nombre cliente</th>
                            <th>Fecha ingreso</th>
                            <th>Cantidad bovinos</th>
                            <th>Total</th>
                            <th>Estado</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {params.results.map((ticket, idx) => (
                            <tr key={idx}>
                              <th scope="row">{ticket.consecutive}</th>
                              <td>{ticket.client}</td>
                              <td>{ticket.client_name}</td>
                              <td>{ticket.created_date}</td>
                              <td>{ticket.animal_number}</td>
                              <td>$ {ticket.total.toLocaleString("es-CO")}</td>
                              {ticket.state === "recibido" && (
                                <td>
                                  <span
                                    className={
                                      "badge rounded-pill bg-warning bg-soft text-warning"
                                    }
                                  >
                                    <b>Recibido</b>
                                  </span>
                                </td>
                              )}
                              {ticket.state === "entregado" && (
                                <td>
                                  <span
                                    className={
                                      "badge rounded-pill bg-success bg-soft text-success"
                                    }
                                  >
                                    <b>Entregado</b>
                                  </span>
                                </td>
                              )}
                              {ticket.state === "cancelado" && (
                                <td>
                                  <span
                                    className={
                                      "badge rounded-pill bg-danger bg-soft text-danger"
                                    }
                                  >
                                    <b>Cancelado</b>
                                  </span>
                                </td>
                              )}
                              <td>
                                <Link to={`/tickets/update/${ticket.code}`}>
                                  <span className="bx bx-edit fa-lg align-middle"></span>
                                </Link>{" "}
                                {ticket.state !== "cancelado" && (
                                  <a
                                    style={{ color: "secondary" }}
                                    onClick={() => {
                                      setTicket({
                                        code: ticket.code,
                                        consecutive: ticket.consecutive,
                                      });
                                      toggle();
                                    }}
                                  >
                                    <span className="bx bx-x fa-lg align-middle"></span>
                                  </a>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination2
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={8}
                      baseUrl="tickets/"
                      filterFunction={ticketFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
              <TicketDelete
                modal={modal}
                toggleFunction={toggle}
                ticket={ticket}
                resetFunction={resetFilter}
              />
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, tickets } = state.Billing;
  return { error, loading, tickets };
};

export default withRouter(connect(mapStateToProps)(TicketList));
